module.exports = __webpack_public_path__ + "static/img/logo_17.3694ef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_17.png
// module id = I63n
// module chunks = 1